import { useState, useMemo } from 'react';
import { getNFTRedeemValues } from 'src/types/nft.ts';
import { NFTRedeemCalculator } from 'src/utils/NFTRedeemCalculator.ts';
import { epochToDate } from 'src/utils/epochUtils';
import { environment } from 'src/config';
import style from './NFTCard.module.scss';
import NFTTimelineDialog from './NFTTimelineDialog';

function NFTCard({ nft, currentEpoch, onClick }) {
    const [dialogOpen, setDialogOpen] = useState(false);
    
    // Memoize the parsed attributes and values
    const parsedAttributes = useMemo(() => 
        NFTRedeemCalculator.parseAttributes(nft.attributes),
        [nft.attributes]
    );

    const currentValues = useMemo(() => 
        getNFTRedeemValues(nft, currentEpoch),
        [nft, currentEpoch]
    );

    const unlockDate = useMemo(() => 
        epochToDate(parsedAttributes.finalEpoch, currentEpoch, environment === 'devnet')
            .toLocaleDateString('en-GB', {
                day: '2-digit',
                month: '2-digit',
                year: '2-digit'
            }),
        [parsedAttributes.finalEpoch, currentEpoch]
    );

    return (
        <div className={style.cardContainer} onClick={onClick}>
            <div className={style.card}>
                <div className={style.front}>
                    <div className={style.imageContainer}>
                        <img src={nft.media[0].thumbnailUrl} alt={nft.identifier} />
                    </div>
                    <div className={style.content}>
                        <h3>{nft.identifier}</h3>
                        <div className={style.values}>
                            <div className={style.row}>
                                <span>Now:</span>
                                <strong className={style.highlight}>
                                    {currentValues.currentValue.toFixed(3)} TADA
                                </strong>
                            </div>
                            <div className={style.row}>
                                <span>Total:</span>
                                <strong>
                                    {(currentValues.maxValue / Math.pow(10, 18)).toFixed(3)} TADA
                                </strong>
                            </div>
                            <div className={style.row}>
                                <span>Unlock:</span>
                                <strong>{unlockDate}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {dialogOpen && (
                <NFTTimelineDialog 
                    open={dialogOpen}
                    onClose={() => setDialogOpen(false)}
                    nft={nft}
                    currentEpoch={currentEpoch}
                    values={currentValues}
                />
            )}
        </div>
    );
}

export default NFTCard; 